import { gql, LazyQueryHookOptions, QueryTuple } from '@apollo/client';

import { useAPILazyQuery } from 'Api/handler';

export type GetTiersResponse = {
  tiers: {
    id: number;
    name: string;
    label: string;
    email?: string;
    code: string;
    type: number;
  }[];
};

export type GetTiersVariables = {
  base: string;
  search: string;
};

export const useGetTiers = (
  options?: LazyQueryHookOptions<GetTiersResponse, GetTiersVariables>,
): QueryTuple<GetTiersResponse, GetTiersVariables> => {
  return useAPILazyQuery(GET_TIERS, options);
};

export const GET_TIERS = gql`
  query GetTiers($base: String!, $search: String!) {
    tiers(base: $base, search: $search) {
      id
      name
      label
      email
      code
      type
    }
  }
`;
